import React from 'react'
import cn from 'classnames'
import { useTranslation } from 'lib/i18n'

import Link from 'components/Link/Link'
import { Button } from 'components/UI/Button/Button'

import styles from './BookOccasionButton.module.css'

const themes = {
  light: styles.lightButton,
  dark: styles.darkButton,
}

type BookOccasionButtonProps = {
  profileSlug: string
  occasionId?: string
  theme?: 'light' | 'dark'
}

const BookOccasionButton = ({
  profileSlug,
  occasionId = '',
  theme = 'light',
}: BookOccasionButtonProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <div className={styles.buttonWrapper}>
      <Link
        href={`/profile/${profileSlug}/product/video-greeting/?occasionId=${occasionId}`}
      >
        <Button
          size="small"
          type="secondary"
          className={cn(styles.button, themes[theme])}
        >
          {t('BookOccasionButton.label', 'Book now')}
        </Button>
      </Link>
    </div>
  )
}

export default BookOccasionButton
